/* prettier-ignore-file */

import * as React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PublicLayout from '../../../bidder/layouts/PublicLayout';

const Faq = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Spanish FAQ list
  const qaEs = [
    {
      question: '¿Qué es Bidder®?',
      answer:
        'El proceso de licitaciones generalmente implica la presentación de una propuesta u oferta de una empresa a un cliente en respuesta a una solicitud de propuesta (RFP), una solicitud de información, y/o una solicitud de cotización. Cada propuesta y requerimientos serán diferentes dependiendo de las necesidades del cliente. FMHOUSE® a través de su herramienta Bidder® revisará las propuestas y seleccionará un postor ganador en función a una evaluación detallada de varios factores, desarrollados para cada licitación.'
    },
    {
      question:
        '¿Cómo funciona el proceso de licitación bajo la metodología de las 3R (RFI, RFP y RFQ) utilizado en Bidder®?',
      answer:
        'Las 3R son las siglas de las tres etapas del proceso de licitación: Request for Information (RFI), Request for Proposal (RFP) y Request for Quotation (RFQ).\nEn la primera etapa, la RFI, entre otros, se solicita información sobre la propia compañia, los productos y/o servicios que se ofrecen, así como la capacidad de proveer el servicio objeto de licitación. Esta etapa permite seleccionar a los proveedores de servicios que mejor se adaptan a las condiciones y necesidades del servicio.\nEn la segunda etapa, la RFP, se solicita una propuesta detallada sobre cómo se proponen proveer los servicios en base al nivel de servicio y condiciones definidas por el cliente, incluyendo, entre otros, información sobre recursos, procedimientos, metodología, reporting, etc.\nEn la última etapa, la RFQ, se solicita una propuesta economica para la provisión de los servicios ofertados. Esta etapa, junto con los resultados de las anteriores, permite garantizar la selección del proveedor que mejor se adapta al servicio y con el mejor equilibrio entre la propuesta técnica y economica.\nEn resumen, el proceso de licitación de las 3R es un proceso estructurado para la adquisición de productos y/o servicios. Está compuesto por tres etapas en las que cada una de las cuales ofrece una información específica para ayudar al comprador a tomar la mejor decisión.'
    },
    {
      question: '¿Cómo sé si mi documento ha sido subido/presentado correctamente?',
      answer:
        'Cuando se sube o firma un documento, queda registrada su carga en la linea del propio requerimiento indicandose la fecha de carga, el nombre del archivo subido y el mensaje "uploaded" que confirma que la carga se ha realizado correctamente. Si no ve dicha información quiere decir que el archivo no se ha subido correctamente, por lo que debera volver a intentarlo hasta que aparezca. Una vez subido el archivo adecuadamente, este quedará pendiente de revisión y aceptación por parte de los gestores de la licitación. '
    },
    {
      question: '¿Cómo sé si mi documento fue aceptado?',
      answer:
        'Una vez se ha subido correctamente el archivo en cuestion, los gestores de la licitación se encargarán de revisar si el archivo subido es correcto y validarlo. En el caso de que este sea aceptado, aparecerá el mensaje "Accepted". En el caso de que este haya sido rechazado, recibirá un correo electronico notificandoselo e indicandole el motivo del rechazo y qué debe hacer para corregirlo. Una vez corregido, deberá volver a subir el archivo para ser nuevamente revisado.'
    },
    {
      question: '¿Puedo modificar mis propuestas despues de que estas hayan sido aceptadas?',
      answer:
        'Por lo general, no es posible modificar las propuestas después de que se hayan aceptado, a no ser que sea requerido por parte de los gestores de la licitación. Si tiene dudas sobre cualquier aspecto relacionado con el proceso, es importante plantearlas antes de presentar una propuesta, para ello todas las fases del proceso disponen de un apartado de preguntas y respuestas (Q&A) en cada etapa del proceso de licitación.'
    },
    {
      question: '¿Cómo sé si he sido seleccionado para la siguiente fase (RFP ó RFQ)?',
      answer:
        'Una vez evaluados los documentos presentados por cada proveedor y validadas las valoraciones por parte del cliente, los gestores de la licitación se encargarán de notificar al proveedor su resultado. En el caso de ser seleccionado para participar en la siguiente fase  esta quedará desbloqueada pudiendo acceder a la información y contenido de esta. En el caso de no ser seleccionado, el acceso a la licitación quedará inhabilitado.'
    },
    {
      question: '¿Puedo retirar una oferta o documento que ya he presentado?',
      answer:
        'De manera general, no es posible retirar una oferta o documento una vez que se ha presentado y finalizado el plazo de presentación. Sin embargo, si hay errores significativos o se considera que el documento presentado no cumple con los requerimientos, se puede solicitar una revisión del mismo. Es importante revisar cada documento y requerimiento detenidamente para asegurarse de que se comprenden los requisitos y términos de lo solicitado. En todo caso, siempre y cuando no haya finalizado el plazo de presentación, se pueden reemplazar todos y cada uno de los documentos presentados tantas veces como se desee, quedando registrada en la plataforma toda la actividad al respecto para su posterior certificación.'
    },
    {
      question: '¿Cómo sé si existe un nuevo requerimiento o notificación?',
      answer:
        'En el caso de existir un nuevo requerimiento o notificación, este le será comunicado a través del correo electronico con el que se ha registrado y que esta vinculado al proceso de licitación. En el apartado de notificaciones puede llevar un control de las notificaciones ya leidas clicando en el botón "Read".'
    },
    {
      question: '¿Puedo acceder a la información de una fase finalizada?',
      answer:
        'No, una vez se finaliza una fase, independientemente de si el participante ha resultado seleccionado para la siguiente, no se puede acceder a la información de fases anteriores.'
    },
    {
      question:
        '¿Puedo acceder a la información una vez ha finalizado la licitación o mi participación en esta? ',
      answer:
        'No, una vez se ha finalizado la participación en la licitacion o esta ha finalizado, no se puede acceder a la información de esta. '
    },
    {
      question:
        '¿Cómo puedo comunicarme con el equipo de gestión de la licitación si tengo un problema con la plataforma?',
      answer:
        'Si tiene cualquier duda técnica referente al funcionamiento de Bidder® puede comunicarse con el equipo de gestión de la licitación a través del siguiente correo electronico: licitaciones@fm-house.com '
    },
    {
      question:
        '¿Cómo puedo comunicarme con el equipo de gestión de la licitación si tengo una duda sobre el proceso de licitación?',
      answer:
        'En el caso de que tenga una duda referente al proceso de licitación, deberá ir a la pantalla de la fase en la que se encuentra y en el apartado "Q&A" clicar en "Ask a question" y escribir su consulta y enviarla en el menu emergente que aparece. Recordar que todas las consultas realizadas sobre el proceso de licitación serán compartidas con todos los participantes para participar en igualdad de condiciones.'
    },
    {
      question: '¿Cómo protejo mi propiedad intelectual durante el proceso?',
      answer:
        'Bidder® es una herramienta diseñada para cuidar cada punto del proceso de desarrollo de una licitación, es por esto que está diseñada para proteger la información compartida por cada licitante. Además al inicio de cualquier licitación se firma un NDA entre las partes con el que se protege de manera legal la información compartida entre estas.'
    }
  ];

  // English FAQ list
  const qaEn = [
    {
      question: 'What is Bidder®?',
      answer:
        'The tender process generally involves the submission of a proposal or offer by a company to a client in response to a Request for Proposal (RFP), a Request for Information (RFI), and/or a Request for Quotation (RFQ). Each proposal and requirement will differ depending on the client’s needs. FMHOUSE®, through its Bidder® platform, will review the proposals and select a winning bidder based on a detailed evaluation of multiple factors defined for each tender.'
    },
    {
      question:
        'How does the tender process work under the 3R methodology (RFI, RFP, and RFQ) used in Bidder®?',
      answer:
        'The “3R” refers to the three stages of the tender process: Request for Information (RFI), Request for Proposal (RFP), and Request for Quotation (RFQ).\nIn the first stage, the RFI, information is requested about the company, its products and/or services, as well as its capacity to deliver the service under tender. This stage allows the selection of service providers that best meet the service conditions and needs.\nIn the second stage, the RFP, a detailed proposal is requested describing how the bidder plans to deliver the services, based on the service levels and conditions defined by the client, including (among other elements) information on resources, procedures, methodology, reporting, etc.\nIn the final stage, the RFQ, a financial proposal is requested for the provision of the offered services. This stage, combined with the results of the previous stages, guarantees the selection of the provider that best fits the service requirements and offers the best balance between technical and financial proposals.\nIn summary, the 3R tender process is a structured approach to the acquisition of products and/or services, with each stage providing specific information to help the client make the best decision.'
    },
    {
      question: 'How do I know if my document has been uploaded/submitted correctly?',
      answer:
        'When a document is uploaded or signed, its submission is recorded in the requirement line, showing the upload date, the file name, and the message “uploaded” confirming successful submission. If this information does not appear, the file was not uploaded correctly, and you must try again until it does. Once successfully uploaded, the file will be pending review and acceptance by the tender managers.'
    },
    {
      question: 'How do I know if my document was accepted?',
      answer:
        'Once the file has been uploaded correctly, the tender managers will review and validate it. If it is accepted, the message “Accepted” will appear. If it is rejected, you will receive an email notifying you of the rejection, including the reason and instructions to correct it. Once corrected, you must re-upload the file for review again.'
    },
    {
      question: 'Can I modify my proposals after they have been accepted?',
      answer:
        'In general, proposals cannot be modified after acceptance unless specifically requested by the tender managers. If you have questions about any aspect of the process, it is important to raise them before submitting your proposal. Each stage of the process includes a Q&A section where you can submit questions.'
    },
    {
      question: 'How do I know if I have been selected for the next phase (RFP or RFQ)?',
      answer:
        'Once the documents submitted by each supplier are evaluated and validated by the client, the tender managers will notify the supplier of the result. If selected for the next phase, it will be unlocked and you will be able to access its information and content. If not selected, access to the tender will be disabled.'
    },
    {
      question: 'Can I withdraw a proposal or document that I have already submitted?',
      answer:
        'Generally, it is not possible to withdraw a proposal or document once it has been submitted and the submission deadline has passed. However, if there are significant errors or if the document does not meet the requirements, you may request a review. It is important to carefully review each document and requirement to ensure full understanding of the conditions before submitting. As long as the submission deadline has not passed, you may replace any and all documents as many times as needed, and all activity will be logged on the platform for certification purposes.'
    },
    {
      question: 'How do I know if there is a new requirement or notification?',
      answer:
        'If there is a new requirement or notification, you will be informed via the email address you used to register for the tender process. In the notifications section, you can keep track of which notifications you have already read by clicking the “Read” button.'
    },
    {
      question: 'Can I access information from a completed phase?',
      answer:
        'No. Once a phase has been completed, regardless of whether the participant was selected for the next phase, it is no longer possible to access information from previous phases.'
    },
    {
      question: 'Can I access information once the tender process or my participation has ended?',
      answer:
        'No. Once your participation or the tender process itself has ended, you can no longer access its information.'
    },
    {
      question:
        'How can I contact the tender management team if I have a technical problem with the platform?',
      answer:
        'If you have any technical questions about how Bidder® works, you can contact the tender management team by email at: licitaciones@fm-house.com'
    },
    {
      question:
        'How can I contact the tender management team if I have a question about the tender process?',
      answer:
        'If you have a question about the tender process, go to the screen for the current phase, click “Ask a question” in the Q&A section, write your question, and submit it in the pop-up window. Remember that all questions submitted about the tender process will be shared with all participants to ensure equal conditions.'
    },
    {
      question: 'How is my information protected?',
      answer:
        'Bidder® is a tool designed to safeguard every step of the tender process, which is why it is built to protect the information shared by each bidder. In addition, at the beginning of each tender, an NDA is signed between the parties to legally protect the information exchanged.'
    }
  ];

  return (
    <PublicLayout title="FAQ">
      <Grid container spacing={3} direction={isMobile ? 'column' : 'row'}>
        <Grid item xs={12} md={6}>
          <Stack spacing={1}>
            <Typography variant={'h3'}>Preguntas frecuentes</Typography>
            {qaEs.map((item, index) => (
              <Accordion key={`es-${index}`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`es-panel-${index}`}
                  id={`es-header-${index}`}>
                  <Typography>{item.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" gutterBottom component="p" whiteSpace="pre-line">
                    {item.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack spacing={1} sx={{ height: '100%' }}>
            <Typography variant={'h3'}>Frequently Asked Questions</Typography>
            {qaEn.map((item, index) => (
              <Accordion key={`en-${index}`}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`en-panel-${index}`}
                  id={`en-header-${index}`}>
                  <Typography>{item.question}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" gutterBottom component="p" whiteSpace="pre-line">
                    {item.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        </Grid>
      </Grid>
    </PublicLayout>
  );
};
export default Faq;
